import { userLogout } from '../api';
import { queryClient } from '../api/query-client';
import cookiesManager from './cookies';
import { USER_DETAILS } from './cookies/keys';

export const handleLogout = async () => {
  const isSso = !!cookiesManager.get(USER_DETAILS.IS_SSO);
  const sourceType = cookiesManager.get(USER_DETAILS.SOURCE_TYPE);

  try {
    await userLogout();
  } finally {
    Object.keys(cookiesManager.getAll()).forEach((cookieName) => {
      cookiesManager.remove(cookieName, { path: '/' });
    });
    queryClient.clear();
    queryClient.resetQueries();
    queryClient.removeQueries();
    let redirectUrl = `${import.meta.env.VITE_BASE_URL ?? ''}/login`;

    if (isSso && sourceType === 'OLD_HR_PORTAL') {
      redirectUrl =
        'https://portals.vidalhealthtpa.com:9443/HrLogins/Default.aspx';
    }

    window.location.href = redirectUrl;
  }
};
